import jwtDecode from "jwt-decode";
const auth = {
	getToken: () => {
		return localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : null
	},
	getUserInfoFromToken: () => {
		const authToken = auth.getGuestToken() || auth.getToken()
		if(!authToken) return {}
		try {
			const decodedToken = jwtDecode(authToken);
			return decodedToken;
		} catch (error) {
			return {}
		}
	},
	getCookieAcception: () => {
		return localStorage.getItem('cookies') ? JSON.parse(localStorage.getItem('cookies')) : null
	},
	getCookieSelections: () => {
		return localStorage.getItem('cookies') ? JSON.parse(localStorage.getItem('cookies')) : null
	},
	getGuestToken: () => {
		return localStorage.getItem('auth') ? JSON.parse(sessionStorage.getItem('auth')) : null
	},
	setGuestToken: (token) => {
		localStorage.setItem('auth',JSON.stringify(token))
	},
	getUserChoises: () => {
		const storage = auth.isGuest() ? sessionStorage.getItem('userChoises') : localStorage.getItem('userChoises')
		return storage ? JSON.parse(storage) : null
	},

	setUserChoises: (userChoises) => {
		auth.isGuest() ? sessionStorage.setItem('userChoises', JSON.stringify(userChoises)) : localStorage.setItem('userChoises', JSON.stringify(userChoises))
	},

	updateUserChoises: (newChoises) => {
		const oldChoises = auth.getUserChoises()

		auth.isGuest() ? sessionStorage.setItem('userChoises', JSON.stringify({ ...oldChoises, ...newChoises })) : localStorage.setItem('userChoises', JSON.stringify({ ...oldChoises, ...newChoises }))
	},

	getPopups: () => {
		return localStorage.getItem('popupList') ? JSON.parse(localStorage.getItem('popupList')) : null
	},

	setPopups: (popupList) => {
		localStorage.setItem('popupList', JSON.stringify(popupList))
	},
	setCookieAcception: (isAccept) => {
		localStorage.setItem('cookies', JSON.stringify(isAccept))
	},
	upsertArray:(array, element) =>  {
		const i = array.findIndex(_element => _element.id === element.id);
		if (i > -1) array[i] = element;
		else array.push(element);
	},
	updatePopups: (newList) => {
		const oldList = auth.getPopups()
		const i = oldList.findIndex(_element => _element.id === newList.id);
		if (i > -1) oldList[i] = newList;
		else oldList.push(newList);
		localStorage.setItem('popupList', JSON.stringify([ ...oldList]))
	},
	getLanguage : () => {
		const lang = JSON.parse(localStorage.getItem('lang'))
		return lang || 'tr'
	},
	clearStorage: () => {
		localStorage.clear()
		//sessionStorage.clear()
	},
	isGuest: () => {
		return  JSON.parse(localStorage.getItem('isGuest')) || null
	},
	transferUserChoises: async() => {
		const seasonUserChoises =  sessionStorage.getItem('userChoises')
		localStorage.setItem('userChoises', seasonUserChoises)
	},
	removeIsGuest: async() => {
		localStorage.removeItem('isGuest')
		sessionStorage.removeItem('userChoises')
	},
	setMemberShip: async () => {
		await auth.transferUserChoises();
		await auth.removeIsGuest()
	},
	isHaveToken: () => {
		return  auth.getGuestToken() || auth.getToken()
	}
}

export default auth
